let e;
const i = () => {
  if (e !== void 0) return e;
  const t = document.createElement("div");
  t.style.visibility = "hidden", t.style.width = "100px", t.style.position = "absolute", t.style.top = "-9999px", document.body.appendChild(t);
  const l = t.offsetWidth;
  t.style.overflow = "scroll";
  const o = document.createElement("div");
  o.style.width = "100%", t.appendChild(o);
  const d = o.offsetWidth;
  return t.parentNode.removeChild(t), e = l - d, e;
};
export {
  i as default
};
//# sourceMappingURL=design-system.es141.js.map
